import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 请求配置统一收敛到 src/api/http.ts，这里不再做全局 axios 配置

//elementui 按需引入
import {
  Container, Header, Aside, Main,
  Button,
  Menu, Submenu, MenuItem,
  Form, FormItem,
  Input,
  Select, Option,
  Switch,
  Table, TableColumn,
  Pagination,
  Message,
  MessageBox
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// 按需引入时，Message / MessageBox 需要手动挂到原型上
Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Button);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Select);
Vue.use(Option);
Vue.use(Switch);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Pagination);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
